import { ProductCode } from '@typings/entities/ProductCode'

export const formatProductCodesToString = (productCodes?: ProductCode[] | string): string | undefined =>
  Array.isArray(productCodes) ? productCodes?.map?.(({ value }) => value).join(', ') : productCodes
